/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { LangsServiceBase } from 'core/services/langs/interfaces';

export const LangContext = React.createContext<LangsServiceBase>({} as LangsServiceBase);
